import GroupServiceApi from '@/api/groupsServiceApi';

const maxInt = 2147483647;

const state = {
  groups: {
    items: [],
    count: 0,
    loading: false,
    page: 1,
    search: '',
    pagesLength: 0,
    take: 10
  },
  groupAssignment: {
    selectedGroup: {
      value: null,
      loading: false
    },
    assignedUsers: {
      items: [],
      count: 0,
      loading: false
    },
    unAssignedUsers: {
      items: [],
      loading: false
    },
    assignedCourses: {
      items: [],
      count: 0,
      loading: false
    },
    unAssignedCourses: {
      items: [],
      loading: false
    },
    courseResults: {
      items: [],
      count: 0,
      loading: false
    }
  }
};

const getters = {
  breadcrumbGroup: state => state.groupAssignment.selectedGroup.value && state.groupAssignment.selectedGroup.value.name
};

const actions = {
  async getAllGroups({ commit, rootState, state }, payload) {
    commit('SAVE_GROUPS_LOADING', { loading: true });

    try {
      payload = payload || { page: state.groups.page, search: state.groups.search };

      let skip = (payload.page - 1) * state.groups.take;
      let { data } = await new GroupServiceApi(rootState.account.token).getGroups(
        payload.search,
        skip,
        state.groups.take
      );

      if (data.result.items.length === 0 && data.result.totalCount > 0) {
        payload.page--;
        skip = (payload.page - 1) * state.groups.take;
        ({ data } = await new GroupServiceApi(rootState.account.token).getGroups(
          payload.search,
          skip,
          state.groups.take
        ));
      }

      commit('SAVE_GROUPS', {
        groups: data.result.items,
        page: payload.page,
        pagesLength: Math.ceil(data.result.totalCount / state.groups.take),
        totalCount: data.result.totalCount,
        search: payload.search
      });
    } catch (e) {
      // TODO: handle
      console.error(e);
    } finally {
      commit('SAVE_GROUPS_LOADING', { loading: false });
    }
  },
  async createGroup({ rootState, dispatch }, payload) {
    try {
      await new GroupServiceApi(rootState.account.token).create(payload.name, payload.isActive);
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllGroups');
  },
  async updateGroup({ rootState, dispatch }, payload) {
    try {
      await new GroupServiceApi(rootState.account.token).update(payload.id, payload.name, payload.isActive);
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllGroups');
  },
  async deleteGroup({ rootState, dispatch }, payload) {
    try {
      await new GroupServiceApi(rootState.account.token).delete(payload.id);
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllGroups');
  },
  async getGroupForEdit({ commit, rootState }, payload) {
    commit('GROUP_FOR_EDIT_LOADING', { loading: true });

    try {
      const { data } = await new GroupServiceApi(rootState.account.token).get(payload.groupId);

      commit('GROUP_FOR_EDIT', { group: data.result });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('GROUP_FOR_EDIT_LOADING', { loading: false });
    }
  },
  async getAssignedUsers({ commit, rootState }, payload) {
    commit('CHANGE_ASSIGNED_USERS_LOADING', { loading: true });

    try {
      const skip = (payload.page - 1) * payload.itemsPerPage;
      const { data } = await new GroupServiceApi(rootState.account.token).getAssignedUsers(
        payload.groupId,
        payload.search,
        skip,
        payload.itemsPerPage > 0 ? payload.itemsPerPage : maxInt
      );

      commit('SAVE_ASSIGNED_USERS', {
        users: data.result.items,
        count: data.result.totalCount
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('CHANGE_ASSIGNED_USERS_LOADING', { loading: false });
    }
  },
  async getUnassignedUsers({ commit, rootState }, payload) {
    commit('CHANGE_UNASSIGNED_USERS_LOADING', { loading: true });

    try {
      const { data } = await new GroupServiceApi(rootState.account.token).getUnassignedUsers(
        payload.groupId,
        payload.query
      );

      commit('SAVE_UNASSIGNED_USERS', {
        users: data.result.items.map(user => ({
          ...user,
          fullName: `${user.name} ${user.surname} (${user.email})`
        }))
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('CHANGE_UNASSIGNED_USERS_LOADING', { loading: false });
    }
  },
  async assignUser({ rootState, dispatch, commit }, payload) {
    commit('CHANGE_ASSIGNED_USERS_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).assignUsersToGroup(
        payload.groupId,
        [payload.userId],
        payload.dateFrom,
        payload.dateTo
      );

      await dispatch('getAssignedUsers', {
        groupId: payload.groupId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  },
  async unAssignUser({ rootState, dispatch, commit }, payload) {
    commit('CHANGE_ASSIGNED_USERS_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).unAssignUsersFromGroup(payload.groupId, [payload.userId]);

      await dispatch('getAssignedUsers', {
        groupId: payload.groupId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  },
  async getAssignedCourses({ commit, rootState }, payload) {
    commit('ASSIGNED_COURSES_LOADING', { loading: true });

    try {
      const skip = (payload.page - 1) * payload.itemsPerPage;
      const { data } = await new GroupServiceApi(rootState.account.token).getAssignedCourses(
        payload.groupId,
        payload.search,
        skip,
        payload.itemsPerPage > 0 ? payload.itemsPerPage : maxInt
      );

      commit('ASSIGNED_COURSES', {
        courses: data.result.items.map(course => ({
          ...course,
          version: `v${course.version.toString().padEnd(3, '.0')}`
        })),
        count: data.result.totalCount
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('ASSIGNED_COURSES_LOADING', { loading: false });
    }
  },
  async getUnassignedCourses({ commit, rootState }, payload) {
    commit('UNASSIGNED_COURSES_LOADING', { loading: true });

    try {
      const { data } = await new GroupServiceApi(rootState.account.token).getUnassignedCourses(
        payload.groupId,
        payload.query
      );

      commit('UNASSIGNED_COURSES', {
        courses: data.result.items.map(course => ({
          ...course,
          displayText: `${course.name} (v${course.version.toString().padEnd(3, '.0')})`
        }))
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('UNASSIGNED_COURSES_LOADING', { loading: false });
    }
  },
  async assignCourse({ rootState, dispatch, commit }, payload) {
    commit('ASSIGNED_COURSES_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).assignCoursesToGroup(
        payload.groupId,
        [payload.courseId],
        payload.dateFrom,
        payload.dateTo,
        payload.keepCourseOngoing
      );

      await dispatch('getAssignedCourses', {
        groupId: payload.groupId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  },
  async unAssignCourse({ rootState, dispatch, commit }, payload) {
    commit('ASSIGNED_COURSES_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).unAssignCoursesFromGroup(payload.groupId, [payload.courseId]);

      await dispatch('getAssignedCourses', {
        groupId: payload.groupId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  },
  async updateCourseAssignment({ rootState, dispatch, commit }, payload) {
    commit('ASSIGNED_COURSES_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).updateCourseAssignment(
        payload.courseAssignmentId,
        payload.dateFrom,
        payload.dateTo,
        payload.keepCourseOngoing
      );

      await dispatch('getAssignedCourses', {
        groupId: payload.groupId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  },
  async getCourseResults({ commit, rootState }, payload) {
    commit('COURSE_RESULTS_LOADING', { loading: true });

    try {
      const skip = (payload.page - 1) * payload.itemsPerPage;
      const { data } = await new GroupServiceApi(rootState.account.token).getAssignedUsersCourseResults(
        payload.groupId,
        payload.courseId,
        payload.search,
        skip,
        payload.itemsPerPage > 0 ? payload.itemsPerPage : null
      );

      commit('COURSE_RESULTS', {
        courseResults: data.result.items,
        count: data.result.totalCount
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('COURSE_RESULTS_LOADING', { loading: false });
    }
  },
  async resetUserCourseResults({ commit, rootState, dispatch }, payload) {
    commit('COURSE_RESULTS_LOADING', { loading: true });

    try {
      await new GroupServiceApi(rootState.account.token).removeAssignedUserCourseResult(
        payload.courseExecutionId,
        payload.userId,
        payload.groupId,
        payload.courseId
      );

      await dispatch('getCourseResults', {
        groupId: payload.groupId,
        courseId: payload.courseId,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }
  }
};

const mutations = {
  SAVE_GROUPS(state, payload) {
    state.groups = {
      ...state.groups,
      items: payload.groups,
      page: payload.page,
      pagesLength: payload.pagesLength,
      count: payload.totalCount,
      search: payload.search
    };
  },
  SAVE_GROUPS_LOADING(state, payload) {
    state.groups = {
      ...state.groups,
      loading: payload.loading
    };
  },
  GROUP_FOR_EDIT(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      selectedGroup: {
        ...state.groupAssignment.selectedGroup,
        value: payload.group
      }
    };
  },
  GROUP_FOR_EDIT_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      selectedGroup: {
        ...state.groupAssignment.selectedGroup,
        loading: payload.loading
      }
    };
  },
  CHANGE_ASSIGNED_USERS_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      assignedUsers: {
        ...state.groupAssignment.assignedUsers,
        loading: payload.loading,
        items: payload.loading ? [] : state.groupAssignment.assignedUsers.items
      }
    };
  },
  SAVE_ASSIGNED_USERS(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      assignedUsers: {
        ...state.groupAssignment.assignedUsers,
        items: payload.users,
        count: payload.count
      }
    };
  },
  CHANGE_UNASSIGNED_USERS_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      unAssignedUsers: {
        ...state.groupAssignment.unAssignedUsers,
        loading: payload.loading,
        items: payload.loading ? [] : state.groupAssignment.unAssignedUsers.items
      }
    };
  },
  SAVE_UNASSIGNED_USERS(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      unAssignedUsers: {
        ...state.groupAssignment.unAssignedUsers,
        items: payload.users
      }
    };
  },
  ASSIGNED_COURSES_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      assignedCourses: {
        ...state.groupAssignment.assignedCourses,
        loading: payload.loading,
        items: payload.loading ? [] : state.groupAssignment.assignedCourses.items
      }
    };
  },
  ASSIGNED_COURSES(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      assignedCourses: {
        ...state.groupAssignment.assignedCourses,
        items: payload.courses,
        count: payload.count
      }
    };
  },
  UNASSIGNED_COURSES_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      unAssignedCourses: {
        ...state.groupAssignment.unAssignedCourses,
        loading: payload.loading,
        items: payload.loading ? [] : state.groupAssignment.unAssignedCourses.items
      }
    };
  },
  UNASSIGNED_COURSES(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      unAssignedCourses: {
        ...state.groupAssignment.unAssignedCourses,
        items: payload.courses
      }
    };
  },
  COURSE_RESULTS_LOADING(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      courseResults: {
        ...state.groupAssignment.courseResults,
        loading: payload.loading,
        items: payload.loading ? [] : state.groupAssignment.courseResults.items
      }
    };
  },
  COURSE_RESULTS(state, payload) {
    state.groupAssignment = {
      ...state.groupAssignment,
      courseResults: {
        ...state.groupAssignment.courseResults,
        items: payload.courseResults,
        count: payload.count
      }
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
